import {ModalBody} from "@/components/modal/index";
import styled from "styled-components";
import {observer} from "mobx-react";
import React, { useState } from "react";
import {ButtonWrap} from "@/styles/CommonStyle";
import Button from "@/components/common/Button";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {FaRegCalendarAlt} from "react-icons/fa";
import {exportToExcelSync, setToast} from "@/utils";
import {useStore} from "@/store";
import moment from "moment";

const ExcelTermModal = observer(({menuId, handleCloseModal, modalDepth, confirmFunc }) => {
    const {boardDetailStore, loadingStore} = useStore();
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    return (
        <ModalBody className={"visible"}>
            <TermWrap>
                <div className="field">
                    <label>시작 날짜</label>
                    <div className={"date-picker-wrap"}>
                        <div className={"picker-ico-wrap"}>
                            <FaRegCalendarAlt/>
                        </div>
                        <DatePicker
                            selected={startDate}
                            onChange={(date) => {
                                setStartDate(date);
                                if (endDate && date && date > endDate) {
                                    setEndDate(null);
                                }
                            }}
                            selectsStart
                            startDate={startDate}
                            endDate={endDate}
                            placeholderText="시작 날짜를 선택해주세요"
                            dateFormat="yyyy-MM-dd"
                            popperPlacement="bottom-start"
                            onChangeRaw={(e) => {
                                e.preventDefault();
                            }}
                        />
                    </div>
                </div>
                <div className="field">
                    <label>종료 날짜</label>
                    <div className={"date-picker-wrap"}>
                        <div className={"picker-ico-wrap"}>
                            <FaRegCalendarAlt/>
                        </div>
                        <DatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            selectsEnd
                            startDate={startDate}
                            endDate={endDate}
                            minDate={startDate}
                            placeholderText="끝나는 날짜를 선택해주세요"
                            dateFormat="yyyy-MM-dd"
                            popperPlacement="bottom-start"
                            onChangeRaw={(e) => {
                                e.preventDefault();
                            }}
                        />
                    </div>

                </div>
            </TermWrap>

            <ButtonWrap className={"center"} $gap={10}>
                <Button
                    type="solid"
                    size="m"
                    round={true}
                    text={"취소"}
                    onClickFunc={async () => {
                        handleCloseModal(modalDepth);
                    }}
                />
                <Button
                    type="fill"
                    size="m"
                    round={true}
                    text={"다운로드"}
                    onClickFunc={async () => {
                        if(!startDate){
                            setToast("warning", "시작 날짜를 설정해 주세요.");
                            return;
                        }
                        if(!endDate){
                            setToast("warning", "종료 날짜를 설정해 주세요.");
                            return;
                        }
                        try {
                            loadingStore.startLoading();
                            loadingStore.setLoadingState(true);
                            const downList = await boardDetailStore.getTermData(menuId, startDate, endDate);
                            if(downList && downList.length <= 0){
                                setToast("warning", "해당 날짜에 데이터가 없습니다.");
                                return;
                            }
                            if(!boardDetailStore.currentBoardContent){
                                setToast("warning", "관리자에 문의 주세요.");
                                return;
                            }
                            const excelData = downList.map((item, index) => ({
                                ...item,
                                num: index + 1,
                            }));
                            const EXCEL_COLUMNS = [
                                { key: "num",      label: "번호" },
                                { key: "updatedAt", label: "작성일" },
                                ...boardDetailStore.formSearchSelectList.map(field => ({
                                    key: field.value,
                                    label: field.label,
                                })),
                                { key: "file", label: "파일명" },
                            ];
                            await exportToExcelSync(excelData, EXCEL_COLUMNS, `${boardDetailStore.currentBoardContent.title}_${moment().format("YYYY-MM-DD HH.mm")}.xlsx`);
                            confirmFunc();
                        } finally {
                            loadingStore.setLoadingState(false);
                        }
                    }}
                />
            </ButtonWrap>
        </ModalBody>
    );
});

const TermWrap = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;
    label{
        font-size: 16px;
    }
    .date-picker-wrap{
        margin-top: 14px;
        display: flex;
        align-items: center;
        border: 1px solid #ccc;
        width: 250px;
        border-radius: 4px;
        overflow: hidden;
        flex-shrink: 0;
        .picker-ico-wrap{
            width: 35px;
            height: 34px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-right: 1px solid #ccc;
            flex-shrink: 0;
        }
        input {
            width: 100%;
            height: 32px;
            padding: 0 16px;
            border: none;
            outline: none;
            cursor: pointer;
            &:focus{
                border: none;
            }
        }
    }
`;

export default ExcelTermModal;
